<div mat-dialog-title>
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <i class="far fa-code-branch i-16 mr-6"></i>
      <span>API Download Link</span>
    </div>
    <div>
      <button trgButton class="dialog-close-btn" (click)="dialogRef.close()">
        <i class="fal fa-times i-12 p-relative"></i>
      </button>
    </div>
  </div>
</div>

<div mat-dialog-content class="px-30 pt-12">
  <ng-container *ngIf="loading$ | async">
    <app-spinner></app-spinner>
  </ng-container>
  <ng-container *ngIf="!(loading$ | async)">
    <div class="dialog-metadata">
      <div class="dialog-metadata__column">
        <div class="dialog-metadata__row">
          <div class="dialog-metadata__label">Name:</div>
          <div class="dialog-metadata__value" [title]="metadata.name">{{metadata.name}}</div>
        </div>
        <div class="dialog-metadata__row">
          <div class="dialog-metadata__label">Dataset:</div>
          <div class="dialog-metadata__value" [title]="metadata.dataset">{{metadata.dataset}}</div>
        </div>
      </div>
      <div class="dialog-metadata__column">
        <div class="dialog-metadata__row">
          <div class="dialog-metadata__label">Type:</div>
          <div class="dialog-metadata__value" [title]="metadata.type">{{metadata.type}}</div>
        </div>
        <div class="dialog-metadata__row" *ngIf="showCurrency">
          <div class="dialog-metadata__label">Currency:</div>
          <div class="dialog-metadata__value" [title]="metadata.currency">{{metadata.currency}}</div>
        </div>
      </div>
    </div>
    <div *ngIf="metadata.isExtendedDataset" class="my-10 fs-10 lh-15 d-flex flex-dir-column" style="background-color: #EBEBEB; padding: 10px 15px;">
      <div class="d-flex">
        <span class="bold fs-12">Refresh Extended Dataset cache before running:</span>
        <trg-checkbox appearance="square" size="small" 
                      class="pl-5 mt-3" style="flex: 0 0 20px;" [value]="refreshDataSet" (valueChange)="refreshDataSet = $event"></trg-checkbox>
      </div>
      <span class="italic">This will override the cache settings, reset the cache duration and refresh the data in this Extended Dataset every time the API link is used.</span>
    </div>
    <div class="my-10 fs-10 lh-15">
      The following URLs allow you to consume the content of this visual via a REST web API into downstream systems such as Microsoft PowerBI or internal applications.<br />
      The data can be retrieved in CSV and JSON formats. Additionally, a "Web Data Connector" URL is provided for Tableau.<br />
      These API links are authenticated using basic web authentication, accessed using an administrator login and password.<br />
      If downloaded from a Dashboard, please note that Dashboard filters will NOT be applied.
    </div>
    <div class="hr-grey-1"></div>
    <div class="mt-25 mb-15">
      <div *ngFor="let link of links" class="d-flex align-items-center justify-content-between mt-6 fs-12 ">
        <div class="bold c-blue" style="flex: 0 0 100px">{{getLinkTitle(link)}}:</div>
        <div class="d-flex align-items-center" style="flex: 1 0 0">
          <input type="text" class="trg-outline bgc-white h-30 lh-30 pl-10" style="flex: 1 0 0" [value]="getLinkUrl(link)" readonly />
          <button trgButton color="primary" class="ml-10 h-30 lh-30" (click)="copyToClipboard(link)">
            <i class="far fa-copy i-12 mr-4"></i>
            <span>Copy Link</span>
          </button>
          <a *ngIf="showOpenLinks" trgButton color="primary" class="ml-10 h-30 lh-30" [href]="link.urlWithToken" target="_blank">
            <i class="far fa-external-link i-12 mr-4"></i> 
            <span>Open Link</span>
          </a>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div mat-dialog-actions align="end" class="dialog-footer px-16 py-10 h-50 border-box">
  <button trgButton color="primary" class="min-w-80" (click)="dialogRef.close()">Close</button>
</div>
